import { TextField } from '@mui/material';
import { useCampaignCreation } from 'pages/AdCampaignPage/CampaignCreationContext';

export interface CampaignDurationProps {}

const CampaignDuration: React.FC<CampaignDurationProps> = () => {
  const {
    state: {
      values: { campaignDuration },
    },
    dispatch,
  } = useCampaignCreation();

  return (
    <TextField
      fullWidth
      placeholder="Campaign duration (optional)"
      value={campaignDuration || ''}
      onChange={(e) =>
        dispatch({
          type: 'CHANGE_VALUES',
          payload: {
            campaignDuration: e.target.value,
          },
        })
      }
    />
  );
};

export default CampaignDuration;
